import React from "react";

import { MoreVert } from "@mui/icons-material";
import { Box, IconButton, Menu, MenuItem } from "@mui/material";
import { v4 as uuidv4 } from "uuid";

export interface IMenu {
	label: string;
	visible: boolean;
	onSelected: () => void;
}
export interface IProps {
	items: IMenu[];
}

const TableRowMenu = ({ items }: IProps) => {
	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);
	const handleClose = () => {
		setAnchorEl(null);
	};
	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};

	return (
		<Box>
			<IconButton
				id="basic-button"
				aria-controls={open ? "basic-menu" : undefined}
				aria-haspopup="true"
				aria-expanded={open ? "true" : undefined}
				onClick={handleClick}
			>
				<MoreVert />
			</IconButton>
			<Menu
				id="basic-menu"
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				slotProps={{
					list: {
						"aria-labelledby": "basic-button"
					}
				}}
			>
				{items
					.filter(i => i.visible)
					.map(item => (
						<MenuItem
							key={uuidv4()}
							onClick={() => {
								item.onSelected();
								handleClose();
							}}
						>
							{item.label}
						</MenuItem>
					))}
			</Menu>
		</Box>
	);
};

export default TableRowMenu;
